import {Component, OnInit, OnDestroy, OnChanges, Input, Output, EventEmitter, ElementRef} from '@angular/core';

// Services
import {CatalogService} from '../../services/catalog-service';
import {AnimateService} from '../../../../shared/services/animate-service';

// Classes
import {ProductCategory} from '../../classes/product-category';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:ProductCategoriesListCmp'));

// TODO: Scroll category into view if new products are added to cart
/** Used to render the product categories navigation list.
 * Standard angular component, no direct access to state store.
 * Lists each selected product bellow the parent category in a tiny, one-line, format.
 * When a category is selected, an event is issued to the parent controller.
 * State is received from parent controller. The component can react to state changes.
 * One specific action that happens on state change is the update of the indicator arrow.
 */
@Component({
    selector: 'product-categories-list-cmp',
    template: require('./product-categories-list.cmp.html'),
    styles: [String(require('./product-categories-list.cmp.scss'))],
    host: { class: 'product-categories-list' }
})
export class ProductCategoriesListCmp {

    @Input() catalogState;
    @Output() categorySelected = new EventEmitter();

    private _rootCategory = [];
    private _subscriptions: any = {};
    private _timeouts: any = {};
    private _prodCategsListElem = null;
    private _indicatorElem = null;
    private _mutationObserver = null;
    private _currentCategoryId = null;
    private _domIsRendered = false;

    
    constructor (
        private _elementRef: ElementRef,
        private _catalogService: CatalogService,
        private _animateService: AnimateService
    ) {
        // 'Construct Product categories list component' );
        this._getProductCategories();
    }

    
    ngOnInit () {
        // 'Initialise product categories list component' );
        this._cacheDomElements();

        // If dom rendered update indicator
        this._onCategoriesListRendered( () => {

            // Run once, just onInit
            if (this._domIsRendered === true) {return;}

            // Detect rendering
            this._domIsRendered === false && ( this._domIsRendered = true );

            // Restore indicator position
            this._slideIndicatorToCategoryId( 800, this._currentCategoryId );
        } );
    }

    
    ngOnChanges (changes) {

        // console.log( 'ngOnChanges changes:', changes );

        let currentCategoryId = this._catalogService.checkCurrentCategoryChanged( changes );

        // Update arrow position if category change is detected after app initialisation
        if (currentCategoryId !== false) {
            this._currentCategoryId = currentCategoryId;

            // console.log( 'ngOnChanges currentCategoryId:', currentCategoryId );

            // Update indicator position
            this._domIsRendered === true && this._slideIndicatorToCategoryId( 800, currentCategoryId );
        }
    }

    
    ngOnDestroy () {
        // 'Destroy Product categories list component' );

        // Unsubscribe events
        for (let subId in this._subscriptions) {
            this._subscriptions[subId].unsubscribe();
        }

        // Disconnect mutation observer
        this._mutationObserver.disconnect();
    }

    
    private _cacheDomElements () {
        // 'Cache DOM elements' );

        this._prodCategsListElem = this._elementRef.nativeElement;
        debugOff( 'Product categories list element:', this._prodCategsListElem );

        this._indicatorElem = this._prodCategsListElem.querySelector( '.indicator' );
        debugOff( 'Indicator element:', this._indicatorElem );
    }

    
    private _getProductCategories () {
        // 'Get product categories' );

        let catalogDataIsLoaded = this._catalogService.checkCatalogDataIsLoaded();

        // Get catalog data either from cache or via subscription
        if (catalogDataIsLoaded === true) {
            debugOff( 'Get catalog cached product categories' );
            this._rootCategory = this._catalogService.getRootCategory();
            debugOff( 'Root category:', this._rootCategory );
        } else {
            debugOff( 'Subscribe for product categories' );
            this._subscriptions.catalogDataLoadedAsync = this._catalogService.events.catalogDataLoadedAsync.subscribe(
                event => {
                    debugOff( 'Subscription for product categories response' );
                    this._rootCategory = event.rootCategory;
                    debugOff( 'Root category async:', this._rootCategory );
                }
            );
        }
    }

    
    private _selectCategory (category) {
        // 'Select "' + category.menuName + '" category' );

        // Emit category change event
        this.categorySelected.emit({
            category: category
        });
    }

    /** Wrapper method, provides the category object from a category id
     */
    private _slideIndicatorToCategoryId (interval: number, categoryId) { // categoryId: string

        // let category = categoryId;

        // if (typeof categoryId === 'string' ) {
            // Get category object
            // debugOff( 'Current category id:', categoryId );
            // 'Current category id:', categoryId );
            let category = this._catalogService.getProductCategoryById( categoryId );
            debugOff( 'Current category:', category );

            // Validate
            if (category === undefined) { console.error('Could not retrieve "' + categoryId + '" category'); return; }
        // }

        // Move Indicator
        this._slideIndicatorToCategory( interval, category );
    }

    
    private _slideIndicatorToCategory (interval: number, category: ProductCategory) {

        // Validate
        if (interval !== null && isNaN(interval)) { console.error('"interval" is not a number'); return; }
        if (this._indicatorElem === null) { console.error('Could not find "indicator" element'); return; }
        if (category === undefined) { console.error('"category" is undefined'); return; }

        // 'Slide indicator to "' + category.id + '" category' );
        debugOff( 'Category id:', category.id );
        debugOff( 'Category:', category );

        let self = this;

        // Get category elements
        // Better to query at runtime than cached. Some categories may be missing, leading to DOM read errors.
        let linkContainer: any = document.querySelector('#' + category.id + '-link-container');
        debugOff( 'Link container:', linkContainer );
        if (linkContainer === null) { console.error('Could not find "#' + category.id + '-link-container" element'); return; }

        let linkElement: any = document.querySelector('#' + category.id + '-link');
        debugOff( 'Link element:', linkElement );
        if (linkElement === null) { console.error('Could not find "#' + category.id + '-link" element'); return; }

        // Compute offset
        let indicatorOffset = this._indicatorElem.offsetTop;
        debugOff( 'Indicator offset:', indicatorOffset );

        let targetOffset = linkContainer.offsetTop + linkElement.offsetTop;
        debugOff( 'Target offset:', targetOffset );

        // Default
        interval === null && (interval = 800);

        // Slide indicator
        this._animateService.start( indicatorOffset, targetOffset, interval, 'easeInOutQuad', (curr, count, max) => {
            self._indicatorElem.style.top = curr + 'px';
        }, this._timeouts, 'slideIndicatorToCategory');
    }

    /** Detects if dom elements have been rendered after ngFor.
     * This step is necessary in order to query the DOM for the newly created elements.
     */
    private _onCategoriesListRendered (callback) {
        // 'Detect when product categories list dom is rendered' );
        this._mutationObserver = new MutationObserver( () => {
            // 'Product categories list dom is rendered' );
            callback();
        } );
        this._mutationObserver.observe( this._prodCategsListElem, {childList: true, subtree: true} );
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/components/product-categories/product-categories-list.cmp.ts